import axios from 'axios';

// Pega a base URL do .env
const baseURL = process.env.REACT_APP_API_URL || "https://api.entradafacil.app/api";


const api = axios.create({
    baseURL,
});

// Interceptador para incluir o token se existir no localStorage ou sessionStorage
api.interceptors.request.use(
    (config) => {
        const token =
            sessionStorage.getItem('token_empresa') ||
            localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            window.location.href = '/admin/login'; // ou use o React Router
        }
        return Promise.reject(error);
    }
);

export default api;
